<template>
  <div class="col-lg-9 col-md-8 col-12">
    <div class="category-grid-list">
      <div class="row">
        <div class="col-12">
          <div class="category-grid-topbar">
            <div class="row align-items-center">
              <div class="col-lg-6 col-md-6 col-12">
                <h3 class="title">{{productListDescription}}</h3>
              </div>
            </div>
          </div>
          <div class="tab-content" id="nav-tabContent">
            <div
              class="tab-pane fade show active"
              id="nav-grid"
              role="tabpanel"
              aria-labelledby="nav-grid-tab"
            >
              <product-card-vue />
              <div class="row">
                <div class="col-12">
                  <!-- Pagination -->
                  <div class="pagination left">
                    <ul class="pagination-list">
                      <li
                        v-for="(page, index) in pagination"
                        :key="index"
                      >
                        <a @click.prevent="changePagination(page)" active href="">{{
                          page
                        }}</a>
                      </li>
                    </ul>
                  </div>
                  <!--/ End Pagination -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCardVue from "./ProductCard.vue";

export default {
  name: "ProductList",
  components: {
    ProductCardVue,
  },
  computed: {
    pagination() {
      let pages = [];
      for (let i = 1; i <= this.$store.state.pagination.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
    productListDescription(){
      let start = 9*this.$store.state.pagination.currentPage-8 
      let end = 9*this.$store.state.pagination.currentPage
      if (end > this.$store.state.pagination.totalItems){
        end = this.$store.state.pagination.totalItems
      }
      return `Showing ${start} - ${end} of Total ${this.$store.state.pagination.totalItems} Products Found`
      }
  },
  methods: {
    changePagination(page){
      let currentQuery = this.$store.state.searchQuery
      let setPage = (currentQuery!== '') ? `&page=${page}` : `/?page=${page}`
      let newQuery = currentQuery+setPage
      this.$router.push(newQuery)
      this.$store.dispatch("fetchProducts");
    }
  },
  created() {
    this.$store.dispatch("fetchProducts");
  },
};
</script>

<style>
</style>